import React from 'react';
import { observer } from 'mobx-react';
import { Neo } from '@singularsystems/neo-react';
import QuestionnaireQuestionAnswerDetail from '../../../Models/Questionnaires/Commands/QuestionnaireQuestionAnswerDetail';
import QuestionnaireAnsweredLookup from '../../../Models/Questionnaires/Queries/QuestionnaireAnsweredLookup';

interface IQuestionMultiSelectDropDownComponentProps {
    questionAnswered: QuestionnaireAnsweredLookup | null;
    questionNumber: number;
    question: QuestionnaireQuestionAnswerDetail;
    disabled: boolean;
}

@observer
export default class QuestionMultiSelectDropDownComponent extends React.Component<IQuestionMultiSelectDropDownComponentProps> {

    public render() {
        const question = this.props.question;
        const questionLabel = this.props.questionNumber + ". " + question.question;
        return (
            <div>
                {question &&
                    <Neo.FormGroup label={questionLabel} bindContext={question.meta.questionAnswerMultiSelectDropDownValues}>
                        <Neo.AutoCompleteDropDown
                            bind={question.meta.questionAnswerMultiSelectDropDownValues}
                            data-tip={question.questionInfoText}
                            disabled={this.props.disabled}
                            // TODO: This currently does not work properly so a re-loaded questionnaire will contain no values for multiselect dropdowns
                            // A Neo fix is required to make this work properly
                            // This is only a minor concern and we can go live without this functionality as most users will complete the questionnaire and move on. 
                            // Those coming back will need to re-capture their answers to multi select drop down questions.
                            bindItems={question.meta.selectedDropDownItems}
                            bindIds={question.questionAnswerMultiSelectDropDownValues}
                            placeholder={question.answerPlaceholder}
                            items={question.dropDownItems}
                            valueMember="itemValue"
                            displayMember="itemDisplay" />
                    </Neo.FormGroup>
                }
            </div>
        )
    }
}